module.exports = __webpack_public_path__ + "img/79.ab267989.jpg";